enum BoundaryType {
  TERRITORY = "territory",
  DEMOGRAPHY = "demography",
}

export default BoundaryType;
